export default {
  FETCH_CHANGE_LOG: "FETCH_CHANGE_LOG",
  FETCH_CHANGE_LOG_SUCCEEDED: "FETCH_CHANGE_LOG_SUCCEEDED",
  FETCH_USERS: "FETCH_USERS",
  RESET_DATA: "RESET_DATA",
  FETCH_USERS_SUCCEEDED: "FETCH_USERS_SUCCEEDED",

}

